import React, { useState, useEffect } from "react";
import DefautPhoto from "../../assets/participantes/user_padrao.jpg";
import api from "../../services/axios";
import useAuth from "../../hooks/useAuthContext";
import { DateTime } from "luxon";
import {
  FaThumbsUp,
  FaHeart,
  FaCommentDots,
  FaRegComment,
} from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";

const Post = (props) => {
  const { usuario } = useAuth();
  const [showInputComentario, setShowInputComentario] = useState(false);
  const [comentario, setComentario] = useState("");
  const [comentou, setComentou] = useState(false);
  const [curtiu, setCortiu] = useState(false);
  const [gostou, setGostou] = useState(false);

  useEffect(() => {
    const coment = props.post.comentariosPostagem.filter((item) => {
      return item?.usuario?.id === usuario?.id;
    });
    setComentou(coment.length > 0);

    const curtir = props.post.curtidasPostagem.filter((curtida) => {
      return curtida.id_usuario === usuario?.id;
    });
    setCortiu(curtir.length > 0);

    const gostar = props.post.gosteisPostagem.filter((gostei) => {
      return gostei.id_usuario === usuario?.id;
    });
    setGostou(gostar.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const handleComentario = async () => {
    let dados = {
      id_postagem: props.post.id,
      comentario: comentario,
    };
    await api.post("comentario-create", dados);
    alert("comentario salvo");
    props.handlePostagem();

    setComentario("");
    setShowInputComentario(false);
  };

  const handleCurtir = async () => {
    let dados = {
      id_postagem: props.post.id,
    };
    await api.post("postagem-curtir", dados);
    props.handlePostagem();
    setComentario("");
    setShowInputComentario(false);
  };

  const handleGostei = async () => {
    let dados = {
      id_postagem: props.post.id,
    };
    await api.post("postagem-gostar", dados);
    props.handlePostagem();
    setComentario("");
    setShowInputComentario(false);
  };

  const handleExcluir = async () => {
    let dados = {
      id_postagem: props.post.id,
    };
    await api.post("postagem-desativar", dados);
    alert("postagem excluida");
    props.handlePostagem();
  };

  const cargoEmpresa = [props.usuario?.cargo, props.usuario?.empresa]
    .filter(Boolean)
    .join(" / ");

  return (
    <article className="home-post">
      <header className="home-post-header">
        <img
          className="home-avatar"
          src={props.avatar ?? DefautPhoto}
          alt=""
        />
        <div className="home-post-meta">
          <div className="home-post-name">{props.usuario?.nome}</div>
          {cargoEmpresa ? (
            <div className="home-post-role">{cargoEmpresa}</div>
          ) : null}
        </div>
      </header>

      <div className="home-post-body">
        {props.imagem ? (
          <img src={props.imagem} alt="" className="home-post-image" />
        ) : null}

        {props.descricao ? (
          <div className="home-post-descricao">{props.descricao}</div>
        ) : null}

        {showInputComentario ? (
          <div className="home-post-comment-form">
            <input
              type="text"
              className="home-post-comment-input"
              placeholder="O que acha desse Post?"
              aria-label="O que acha desse Post?"
              value={comentario}
              onChange={(e) => {
                setComentario(e.target.value);
              }}
            />
            <button
              className="apl-btn apl-btn--secondary"
              type="button"
              onClick={() => {
                handleComentario();
              }}
            >
              <FaRegComment aria-hidden />
              Enviar
            </button>
          </div>
        ) : null}

        <div className="home-post-actions">
          <div className="home-post-actions-btns">
            <button
              type="button"
              className={`home-post-icon${curtiu ? " is-active" : ""}`}
              onClick={() => {
                handleCurtir();
              }}
              title="Curtir"
              aria-label="Curtir"
              aria-pressed={curtiu}
            >
              <FaThumbsUp size={14} aria-hidden />
            </button>
            <button
              type="button"
              className={`home-post-icon${gostou ? " is-active" : ""}`}
              onClick={() => {
                handleGostei();
              }}
              title="Gostar"
              aria-label="Gostar"
              aria-pressed={gostou}
            >
              <FaHeart size={14} aria-hidden />
            </button>
            <button
              type="button"
              className={`home-post-icon${comentou ? " is-active" : ""}`}
              onClick={() => {
                setShowInputComentario(!showInputComentario);
              }}
              title="Comentar"
              aria-label="Comentar"
              aria-pressed={showInputComentario}
            >
              <FaCommentDots size={14} aria-hidden />
            </button>
            {props.post.id_usuario === usuario.id ? (
              <button
                type="button"
                className="home-post-icon home-post-icon--danger"
                onClick={() => {
                  handleExcluir();
                }}
                title="Excluir postagem"
                aria-label="Excluir postagem"
              >
                <AiFillDelete size={16} aria-hidden />
              </button>
            ) : null}
          </div>
          <div className="home-post-stats">
            <span>{props?.post?.comentariosPostagem.length} comentários</span>
            <span>{props?.post?.curtidasPostagem.length} curtidas</span>
            <span>{props?.post?.gosteisPostagem.length} gostei</span>
          </div>
        </div>

        {props?.post?.comentariosPostagem.length > 0 ? (
          <div className="home-post-comments">
            {props.post.comentariosPostagem.map((item, index) => {
              let duracao = DateTime.now()
                .minus({ hour: 3 })
                .diff(DateTime.fromISO(item.created_at), [
                  "days",
                  "hours",
                  "minutes",
                ]);

              let textTempo = "";
              if (duracao.values.days > 0) {
                textTempo = `à ${duracao.values.days} dia${
                  duracao.values.days > 1 ? "s" : ""
                }`;
              } else if (duracao.values.hours > 0) {
                textTempo = `à ${parseInt(duracao.values.hours)} hora${
                  duracao.values.hours > 1 ? "s" : ""
                }`;
              } else {
                textTempo = `à ${parseInt(duracao.values.minutes)} min`;
              }

              return (
                <div
                  key={item.id ?? `${props.post.id}-comentario-${index}`}
                  className="home-post-comment"
                >
                  <div className="home-post-comment-head">
                    <span className="home-post-comment-author">
                      {item.usuario?.nome}:
                    </span>
                    <span className="home-post-comment-time">{textTempo}</span>
                  </div>
                  <div className="home-post-comment-text">{item.comentario}</div>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </article>
  );
};

export default Post;
